import { render, staticRenderFns } from "./sonEditLabel.vue?vue&type=template&id=d3786784&scoped=true"
import script from "./sonEditLabel.vue?vue&type=script&lang=js"
export * from "./sonEditLabel.vue?vue&type=script&lang=js"
import style0 from "./sonEditLabel.vue?vue&type=style&index=0&id=d3786784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3786784",
  null
  
)

export default component.exports